import React from 'react';

const WriteNewMsgIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.6668 10.5983V14.9908C16.6668 15.9167 16.0216 16.6667 15.2253 16.6667H4.77498C3.97868 16.6667 3.3335 15.9167 3.3335 14.9917V5.00833C3.3335 4.08333 3.97868 3.33333 4.77498 3.33333H7.93667"
      stroke="white"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2182 2.92031C14.7782 2.36031 15.6865 2.35948 16.2465 2.92031V2.92031C16.8065 3.48031 16.8065 4.38865 16.2457 4.94865L11.434 9.75615C11.2782 9.91198 11.0665 9.99948 10.8457 9.99948H9.1665V8.32031C9.1665 8.09948 9.254 7.88781 9.41067 7.73115L14.2182 2.92031V2.92031Z"
      stroke="white"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.3585 5.83278L13.3335 3.80778"
      stroke="white"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default WriteNewMsgIcon;
